import VueCompositionApi from '@vue/composition-api'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueCytoscape from 'vue-cytoscape'
import JsonViewer from 'vue-json-viewer'
import hljs from 'highlight.js/lib/index';
import highlightjsVuePlugin from "@highlightjs/vue-plugin";

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

Vue.use(VueCompositionApi)
Vue.use(VueLodash, { lodash: lodash })
Vue.use(VueCytoscape)
Vue.use(highlightjsVuePlugin)
Vue.use(JsonViewer)

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

Vue.prototype.global = window;

Vue.prototype.$echo = Echo;

window.EnvMixin = {
    data() {
        return {
            env: {
                app_env: process.env.MIX_APP_ENV,
                app_debug: process.env.MIX_APP_DEBUG,
            }
        };
    },
}

Vue.directive('dusk', {
    bind: function (el, binding) {
        if (process && process.env.MIX_APP_ENV && process.env.MIX_APP_ENV.toUpperCase() !== 'PRODUCTION') {
            el.setAttribute('dusk', binding.value)
        }
    }
})

window.EchoMixin = {
    created() {
        this.$echo.connector.socket.on('connect', () => {
            this.echoErrors = [];
        });
        this.$echo.connector.socket.on('disconnect', () => {
            this.echoErrors.push({
                error: 'disconnected',
                context: {
                    datetime: new Date(),
                }
            });
        });
        this.$echo.connector.socket.on('subscription_error', (channel, statusCode) => {
            this.echoErrors.push({
                error: 'auth_error',
                context: {
                    channel: channel,
                    statusCode: statusCode,
                }
            });
        });
    },

    data() {
        return {
            socket: this.$echo.connector.socket,
            echoErrors: [],
        };
    },

    computed: {
        echoConnected() {
            if (this.$echo && this.socket) {
                return this.socket.connected;
            }
            return false;
        },

        echoHasErrors() {
            return this.echoErrors.length > 0;
        },

        echoConnectedWihoutErrors() {
            return this.echoConnected && !this.echoHasErrors;
        },
    }
};
